export const AnalyticsUserProperties = {
  CompanyID: 'company_id',
  CompanyName: 'company_name',
  CompanyAccountType: 'company_account_type',
  UserID: 'user_id',
  UserAge: 'user_age',
  UserGender: 'user_gender',
  UserRole: 'user_role',
  UserOriginator: 'user_originator',
  UserAccountType: 'user_account_type',
} as const;
